// @ts-strict-ignore
import React from 'react';

import { PublicPage } from 'api/website';
import { SocialButton } from 'components/SocialButton';

type Props = {
  content: PublicPage;
  message: string | null | undefined;
  title: string;
  subsite: string;
};

export function CmsSocialButtons({ content, message, title, subsite }: Props) {
  return (
    <>
      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="facebook"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="twitter"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="linkedin"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />
    </>
  );
}
